<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{$t('message.标签清洗')}}</span>
    </div>
    <div class="grid-content content-margin">
      <el-steps :active="activeStep" :space="300" finish-status="success">
        <el-step title="Step 1" :description="$t('message.选择标签')"></el-step>
        <el-step title="Step 2" :description="$t('message.上传用户')"></el-step>
        <el-step title="Step 3" :description="$t('message.提交标签')"></el-step>
      </el-steps>
    </div>
    <div class="grid-content subtitle" :class="{'subtitle-currentstep': activeStep == 0}">
      <span>{{$t('message.选择需处理的标签')}}</span><i v-show="activeStep >= 1" class="el-icon-success red-icon"></i>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">  
        <el-link
          :underline="false"
        >
        <el-button :disabled="activeStep > 0" :type="(activeStep == 0 && tableData.length == 0) ? 'primary' : '' " size="medium" icon="el-icon-plus" round @click="ismulti = true; showTagStore = true;">
          {{$t('message.添加')}}
        </el-button>
        </el-link>
        <el-link
          :underline="false"
        >
        <el-button size="medium" icon="el-icon-delete" round @click.native="clearTag">
          {{$t('message.清空')}}
        </el-button>
        </el-link>
        <el-link
          :underline="false"
        >
        <el-button :disabled="activeStep > 0 || (tableData.length == 0) || (reverseidError && useReverseSwitch)" :type=" (activeStep == 0 && tableData.length > 0) ? 'primary' : '' " size="medium" icon="el-icon-upload2" round @click.native="sethandletags">
          {{$t('message.提交')}}
        </el-button>
        </el-link>
      </div>
      
    </div>
    <div v-show="tableData.length > 0" class="grid-content content-margin">
      <table class="simpleRow">
        <tr>
          
          <td>
            <span class="simpleLabel">{{$t('message.进行CSV字段名称转换')}}</span>
          </td>
          <td>
            <el-switch
              :disabled="activeStep > 0"
              v-model="useGPIDCovertSwitch"
              :active-text="$t('message.开启')"
              :inactive-text="$t('message.关闭')">
            </el-switch>
          </td>
          <td>
            <el-button v-if="showTableFlg == false" size="mini" icon="el-icon-zoom-in" circle @click="onZoomClick(true);"></el-button>
            <el-button v-if="showTableFlg == true"  size="mini" icon="el-icon-zoom-out" circle @click="onZoomClick(false);"></el-button>
          </td>
        </tr>
      </table>
    </div>
    <div v-show="tableData.length > 0 && showTableFlg" class="grid-content content-margin">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :height="473"
        >
        <el-table-column
          type="index"
          label="No."
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          :label="$t('message.标签ID')"
          width="200">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('message.标签名称')"
          >
        </el-table-column>
        <el-table-column
          prop="gpid"
          :label="$t('message.CSV对应字段名称')">
        </el-table-column>
        <el-table-column :label="$t('message.操作')" width="160" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button v-if="useGPIDCovertSwitch" :disabled="activeStep > 0 || tableData.length == 0" size="mini" round :type=" (activeStep == 0) ? 'primary' : '' " icon="el-icon-edit" @click="editDialogVisible = true; targetRow = scope.row; tempName = scope.row.gpid;"></el-button>
              <el-button :disabled="activeStep > 0 || tableData.length == 0" size="mini" :round="useGPIDCovertSwitch" :circle="!useGPIDCovertSwitch" type="normal" icon="el-icon-delete" @click="deleteDialogVisible = true; targetRow = scope.$index;"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="grid-content content-margin">
      <el-divider></el-divider>
      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">{{$t('message.设置反向标签')}}</span>
          </td>
          <td>
            <el-switch
              :disabled="activeStep > 0"
              v-model="useReverseSwitch"
              :active-text="$t('message.开启')"
              :inactive-text="$t('message.关闭')">
            </el-switch>
          </td>
          <td >
            <el-input v-show="useReverseSwitch" v-model="reverseid" readonly clearable :placeholder="$t('message.请选择标签ID')"></el-input>
          </td>
          <td>
            <el-button :disabled="activeStep > 0" type="primary" v-show="useReverseSwitch" @click="ismulti = false; showTagStore = true;" size="mini" round>选择</el-button>
          </td>
          <td>
            <div v-show="useReverseSwitch && reverseidError" style="height: 40px; position: relative; line-height:46px;">
              <i class="el-icon-error red-icon"></i>
              <span style=" width:200px; position:absolute; left: 24px; top: -3px;">{{$t('message.错误与待处理标签有重复')}}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="grid-content subtitle" :class="{'subtitle-currentstep': activeStep == 1}">
      <span>{{$t('message.上传用户数据CSV文件')}}</span><i v-show="activeStep >= 2" class="el-icon-success red-icon"></i>
    </div>
    <div v-show="activeStep == 1" class="grid-content content-margin">
      <div style="width: 360px;">
        <el-upload
          ref="uploadcom"
          name="file"
          class="upload-demo"
          drag
          action="/manage/wechat/uploaduser"
          :limit="1"
          :auto-upload="false"
          :file-list="uploadList"
          :on-preview="handlePreview"
          :on-exceed="handleExceed"
          :on-success="handleSuccess"
          :on-error="upError"
          :on-change="onUploadChange"
          :on-remove="onUploadRemove"
          >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{$t('message.将文件拖到此处')+'或'}}<em>{{$t('message.点击上传')}}</em></div>
          
          <div class="el-upload__tip" slot="tip">{{$t('message.只能上传文件')}}</div>
        </el-upload>
      </div>
      
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">  
        <el-link
            v-show="activeStep >= 2" 
            :underline="false"
        >
        <el-button :disabled="activeStep >= 3" size="medium" icon="el-icon-delete" round @click="clearuser">
          {{$t('message.清空')}}
        </el-button>
        </el-link>
        <el-link
            v-show="activeStep < 2"
            :underline="false"
        >
        <el-button :disabled="activeStep < 1 || uploadList.length == 0" :type="activeStep == 1 ? 'primary' : '' " size="medium" icon="el-icon-upload2" round @click="uploaduser">
          {{$t('message.上传')}}
        </el-button>
        </el-link>
        <el-link
          href="/manage/wechat/exportduplicateuserlist"
          v-show="activeStep == 2"
          :underline="false"
        >
          <el-button size="medium" icon="el-icon-download" round>
            {{$t('message.下载报告')}}
          </el-button>
        </el-link>
      </div>
      
    </div>

    <div class="grid-content subtitle" :class="{'subtitle-currentstep': activeStep == 2}">
      <span>{{$t('message.提交数据至微信')}}</span><i v-show="activeStep >= 3" class="el-icon-success red-icon"></i>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">  
        <el-link :underline="false">
          <el-button :disabled="activeStep < 2 || activeStep >= 3" :type="activeStep == 2 ? 'primary' : '' "  size="medium" icon="el-icon-thumb" round @click="doCommit">
            {{$t('message.提交')}}
          </el-button> 
        </el-link>
        <span v-show="activeStep == 2">{{$t('message.提交标签需要较长时间完成')}}</span>
        <el-link href="/manage/wechat/exportcommitreport" v-show="activeStep >= 3" :underline="false">
          <el-button size="medium" icon="el-icon-download" round >
            {{$t('message.下载报告')}}
          </el-button>
        </el-link>
      </div>
      
    </div>
    <shade v-if="showTagStore">
      <wechat-tag-store
        v-bind:ismulti="ismulti"
        @onClick="onStoreClick"
      ></wechat-tag-store>
    </shade>
    <el-dialog
      :title="$t('message.编辑转换名称')"
      :visible.sync="editDialogVisible"
      width="400px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <textarea
          wrap="soft|hard"
          class="dialog-textarea"
          v-model="tempName"
          :placeholder="$t('message.请输入标签转换名称')"
          @keyup.enter.stop="createTag"
        />
      <span slot="footer" class="dialog-footer">
        <el-button round size="small" @click="editDialogVisible = false;">{{$t('message.取消')}}</el-button>
        <el-button round size="small" type="primary" @click.native="editTag">{{$t('message.编辑')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
    >
        <i class="iconfont" >&#xe766;</i>
        <span>{{$t('message.请确认是否删除该标签')}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button round size="small" @click="deleteDialogVisible = false">{{$t('message.取消')}}</el-button>
          <el-button round size="small" type="primary" @click.native="deleteTag">{{$t('message.删除')}}</el-button>
        </span>
    </el-dialog>
    <el-dialog
      :title="$t('message.正在上传用户数据')"
      :visible.sync="userUploadDialogVisible"
      width="600px"
      :modal="true"
      center
      :show-close="false"
      :before-close="handleClose"
    >
      <el-row>
        <span class="simpleLabel" style="margin-bottom: 10px;">{{$t('message.当前状态')}}{{progressState}}{{dot}}</span>
      </el-row>
      <el-row>
      <el-progress :text-inside="true" :stroke-width="16" :percentage="percentageUserUpload"></el-progress>
      </el-row>
      <el-table v-show="reportUserUpload.length > 0" :data="reportUserUpload">
        <el-table-column prop="name" :label="$t('message.导入结果报告')" ></el-table-column>
        <el-table-column prop="count" :label="$t('message.数量')" ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-link
          href="/manage/wechat/exportduplicateuserlist"
          v-show="activeStep >= 2" 
          :underline="false"
        >
          <el-button size="small" icon="el-icon-download" round>
            {{$t('message.下载')}}
          </el-button>
        </el-link>
        <el-button v-if="!endUserupload" round size="small" @click="cancelUserUpload">{{$t('message.取消')}}</el-button>
        <el-link
          v-else
          :underline="false"
        >
          <el-button type="primary" round size="small" @click.native="onEndUseruploadClick">{{$t('message.确定')}}</el-button>
        </el-link>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('message.正在对标签进行清洗')"
      :visible.sync="commitTagDialogVisible"
      width="600px"
      :modal="true"
      center
      :show-close="false"
      :before-close="handleClose"
    >
      <el-row>
        <span class="simpleLabel" style="margin-bottom: 10px;">{{$t('message.当前状态')}}{{progressStateCommit}}{{dot}}</span>
      </el-row>
      <el-row>
        <el-progress :text-inside="true" :stroke-width="16" :percentage="percentageCommitTag"></el-progress>
      </el-row> 
      <el-table v-show="reportCommitTag.length > 0" :data="reportCommitTag">
        <el-table-column prop="name" :label="$t('message.清洗结果报告')" ></el-table-column>
        <el-table-column prop="count" :label="$t('message.数量')" ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-link
          href="/manage/wechat/exportcommitreport"
          v-show="activeStep >= 3" 
          :underline="false"
        >
          <el-button size="small" icon="el-icon-download" round>
            {{$t('message.下载')}}
          </el-button>
        </el-link>
        <el-button v-if="!endCommitTag" round size="small" @click="cancelCommitTag">{{$t('message.取消')}}</el-button>
        <el-link
          v-else
          :underline="false"
        >
          <el-button type="primary" round size="small" @click.native="onEndCommitTagClick">{{$t('message.确定')}}</el-button>
        </el-link>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import wechatTagStore from "@/components/wechat/wechatTagStore";
import shade from "@/components/shade/shade";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "CommitTag",
  components: {
    shade,
    wechatTagStore,
  },
  data() {
    return {
      activeStep: 0,
      showTagStore: false,
      useGPIDCovertSwitch: false,
      ismulti: false,
      filterText: "",
      showTableFlg: true,
      tableData: [],
      userUploadDialogVisible: false,
      percentageUserUpload: 0,
      endUserupload: false,
      useReverseSwitch: false,
      reverseid: "",
      commitTagDialogVisible: false,
      percentageCommitTag: 0,
      endCommitTag: false,
      editDialogVisible: false,
      tempName: "",
      deleteDialogVisible: false,
      uploadList: [],
      timeHandle: null,
      timeHandleCommit: null,
      timedotCount: 0,
      progressState: "",
      progressStateCommit: "",
      reportUserUpload: [],
      reportCommitTag: [{ name: "11", count: 1 }],
      reverseidError: false,
    };
  },
  watch: {},
  methods: {
    onZoomClick(flg) {
      this.showTableFlg = flg;
      window.setTimeout(() => {
        this.$refs.table.doLayout();
      }, 10);
    },
    onStoreClick(doc) {
      this.showTagStore = !this.showTagStore;
      if (this.ismulti) {
        if (doc.sel) {
          this.tableData = doc.sel;
          this.tableData.forEach((element) => {
            this.$set(element, "gpid", element.name);
          });
          this.showTableFlg = true;
        }
      } else {
        this.reverseid = doc.reverseid;
      }
      this.checkReverseExistErr();
    },
    checkReverseExistErr() {
      this.reverseidError = false;
      this.tableData.forEach((element) => {
        if (element.name == this.reverseid) {
          this.reverseidError = true;
          this.$message({
            type: "error",
            message: this.$t('message.错误与待处理标签有重复'),
          });
        }
      });
    },
    editTag() {
      console.log(this.tableData);
      let gpid = this.tempName.replace(/[\r\n]/g, "");
      this.$set(this.targetRow, "gpid", gpid);
      this.editDialogVisible = false;
    },
    deleteTag() {
      console.log(this.targetRow);
      this.deleteDialogVisible = false;
      this.tableData.splice(this.targetRow, 1);
      this.checkReverseExistErr();
    },
    sethandletags() {
      // 发送设置标签协议
      this.$http
        .post("/manage/wechat/sethandletags", {
          tags: this.getHandelTags(),
          reverse: this.useReverseSwitch ? this.reverseid : "",
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.activeStep = 1;
            this.showTableFlg = false;
          }
        });
    },
    getHandelTags() {
      let tags = [];
      this.tableData.forEach((element) => {
        let name;
        if (this.useGPIDCovertSwitch) name = element.gpid;
        else name = element.name;
        tags.push({ id: element.id, name: name });
      });
      return tags;
    },
    clearTag() {
      this.reverseid = "";
      if (this.tableData.length == 0) return;
      // 发送清除标签协议
      this.$http.post("/manage/wechat/clearhandletags", {}).then((doc) => {
        if (doc.data.Code != "MSGKEY_OK") {
          this.$message({
            type: "error",
            message: doc.data.Message,
          });
        } else {
          this.tableData = [];
          this.activeStep = 0;
          this.$refs.uploadcom.clearFiles();
        }
      });
    },
    clearuser() {
      this.$http.post("/manage/wechat/clearusers", {}).then((doc) => {
        if (doc.data.Code != "MSGKEY_OK") {
          this.$message({
            type: "error",
            message: doc.data.Message,
          });
        } else {
          this.activeStep = 1;
          this.$refs.uploadcom.clearFiles();
        }
      });
    },
    handlePreview(file) {
      // console.log(file);
    },
    onUploadChange(file, fileList) {
      // 这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
      let ary = file.name.split(".");
      if (ary.length < 2) {
        this.$message.error(this.$t('message.只能上传文件'));
        fileList.pop();
        return false;
      }
      console.log(ary[1].toLowerCase());
      const isCSV =
        ary[1].toLowerCase() === "csv" || ary[1].toLowerCase() === "zip";
      if (!isCSV) {
        this.$message.error(this.$t('message.只能上传文件'));
        fileList.pop();
        return false;
      }
      this.uploadList = fileList;
    },
    onUploadRemove(file, fileList) {
      this.uploadList = fileList;
    },
    // 这里要分成上传状态, 处理error
    uploaduser() {
      this.$refs.uploadcom.submit();
    },
    upError(err, file, fileList) {
      // 上传失败钩子
      console.log(err);
      this.$message({
        type: "error",
        message: err,
      });
    },
    handleSuccess(res, file) {
      if (res.result) {
        this.$message({
          type: "error",
          message: res.data.Message,
        });
      } else {
        console.log(res);
        // 打开进度条面板
        this.percentageUserUpload = 0;
        this.endUserupload = false;
        this.reportUserUpload = [];
        this.userUploadDialogVisible = true;
        // 开启定时器
        window.clearInterval(this.timeHandle);
        this.timeHandle = setInterval(() => {
          this.onProgressUser();
        }, 400);
      }
    },
    handleExceed() {
      this.$message({
        type: "warning",
        message: this.$t('message.每次最多上传1个文件'),
      });
    },
    onProgressUser() {
      this.timedotCount++;
      if (this.timedotCount > 3) {
        this.timedotCount = 0;
      }

      // 发送请求
      this.$http.get("/manage/wechat/progressuserupload", {}).then((doc) => {
        // console.log(doc.data)
        if (doc.data.Code != "MSGKEY_OK") {
          this.$message({
            type: "error",
            message: doc.data.Message,
          });
          // 如果完成了就停下计时器
          clearInterval(this.timeHandle);
          this.timeHandle = null;
          this.timedotCount = 0;
          this.endUserupload = true;
          this.progressState = doc.data.Message;
        } else {
          let data = doc.data.data;
          this.percentageUserUpload =
            data.total == 0 ? 0 : parseInt((data.progress / data.total) * 100);

          if (data.ExtendData) {
            this.reportUserUpload = data.ExtendData;
          }

          this.progressState =
            data.Message + " (" + data.progress + "/" + data.total + ")";
          if (doc.data.data.isEnd == true) {
            // 如果完成了就停下计时器
            clearInterval(this.timeHandle);
            this.timeHandle = null;
            this.timedotCount = 0;
            this.endUserupload = true;

            if (doc.data.data.data == "COMPLETE") {
              this.activeStep = 2;
            }
            if (doc.data.data.data == "FAIL") {
              this.$message({
                type: "error",
                message: doc.data.data.Message,
              });
            }
          }
        }
      });
    },
    cancelUserUpload() {
      this.$confirm(this.$t('message.确认取消'))
        .then((_) => {
          this.$http.post("/manage/wechat/canceluserupload", {}).then((doc) => {
            if (doc.data.Code != "MSGKEY_OK") {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            } else {
              this.userUploadDialogVisible = false;
              clearInterval(this.timeHandle);
              this.timeHandle = null;
              this.activeStep = 1;
              this.$refs.uploadcom.clearFiles();
              this.uploadList = [];
              this.clearuser();
            }
          });
        })
        .catch((_) => {});
    },
    onEndUseruploadClick() {
      this.userUploadDialogVisible = false;
    },
    doCommit() {
      this.$confirm(this.$t('message.已确认无误并提交标签吗'))
        .then((_) => {
          // 提交
          this.$http.post("/manage/wechat/commitusertag", {}).then((doc) => {
            if (doc.data.Code != "MSGKEY_OK") {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            } else {
              // 打开进度条面板
              this.percentageCommitTag = 0;
              this.endCommitTag = false;
              this.reportCommitTag = [];
              this.commitTagDialogVisible = true;
              // 开启定时器
              window.clearInterval(this.timeHandleCommit);
              this.timeHandleCommit = setInterval(() => {
                this.onProgressCommit();
              }, 400);
            }
          });
        })
        .catch((_) => {});
    },
    onProgressCommit() {
      this.timedotCount++;
      if (this.timedotCount > 3) {
        this.timedotCount = 0;
      }

      // 发送请求
      this.$http.get("/manage/wechat/progresscommittag", {}).then((doc) => {
        console.log(doc.data);
        if (doc.data.Code != "MSGKEY_OK") {
          this.$message({
            type: "error",
            message: doc.data.Message,
          });
          // 如果完成了就停下计时器
          clearInterval(this.timeHandleCommit);
          this.timeHandleCommit = null;
          this.timedotCount = 0;
          this.endCommitTag = true;
          this.progressStateCommit = doc.data.Message;
        } else {
          let data = doc.data.data;
          this.percentageCommitTag =
            data.total == 0 ? 0 : parseInt((data.progress / data.total) * 100);

          if (data.ExtendData) {
            this.reportCommitTag = data.ExtendData;
          }

          this.progressStateCommit =
            data.Message + " (" + data.progress + "/" + data.total + ")";
          if (doc.data.data.isEnd == true) {
            // 如果完成了就停下计时器
            clearInterval(this.timeHandleCommit);
            this.timeHandleCommit = null;
            this.timedotCount = 0;
            this.endCommitTag = true;

            if (doc.data.data.data == "COMPLETE") {
              this.activeStep = 3;
            }
            if (doc.data.data.data == "FAIL") {
              this.$message({
                type: "error",
                message: doc.data.data.Message,
              });
            }
          }
        }
      });
    },
    cancelCommitTag() {
      this.$confirm(this.$t('message.确认取消'))
        .then((_) => {
          this.$http
            .post("/manage/wechat/cancelcommitusertag", {})
            .then((doc) => {
              if (doc.data.Code != "MSGKEY_OK") {
                this.$message({
                  type: "error",
                  message: doc.data.Message,
                });
              } else {
                this.clearTag();
                this.commitTagDialogVisible = false;
                clearInterval(this.timeHandleCommit);
                this.timeHandleCommit = null;
              }
            });
        })
        .catch((_) => {});
    },
    onEndCommitTagClick() {
      this.commitTagDialogVisible = false;
    },
    getTableRow(id) {
      this.tableData.forEach((element) => {
        if (element.id == id) return element;
      });
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    dot() {
      switch (this.timedotCount) {
        case 1:
          return ".";
        case 2:
          return "..";
        case 3:
          return "...";
      }
      return "";
    },
  },
  //Vue 表单未保存离开页面提醒
  beforeRouteLeave(to, from, next) {
    if (this.activeStep == 0 || this.activeStep == 3) {
      next();
    } else {
      const answer = window.confirm(this.$t('message.您的编辑还未保存是否离开'));
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/wechatTag/CommitTag.vue